import React from "react";
import * as FaIcons from "react-icons/fa";
import * as RiIcons from "react-icons/ri";

export const SidebarDataElectronicBilling = [
    {
        id: "ElectronicBillingIndex",
        title: "default_bills",
        path: "/ElectronicBilling/ElectronicBillingIndex",
        icon: <FaIcons.FaFileInvoice />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        isClicked: false,
    },
    {
        id: "ElectronicDocument",
        title: "electronic_documents",
        path: "/ElectronicBilling/ElectronicDocument",
        icon: <FaIcons.FaFileContract />,
        iconClosed: <FaIcons.FaChevronDown className="arrowIcon" />,
        iconOpened: <FaIcons.FaChevronDown className="arrowIcon" />,
        isClicked: false,
        adminOnly: true,
        subNav: [
            {
                title: "send",
                path: "/ElectronicBilling/ElectronicDocument",
                icon: <FaIcons.FaCircle className="iconSubmenu" />,
                id: "electronicDocument"
            },
            {
                title: "invalidate",
                path: "/ElectronicBilling/InvoiceNumberInvalidate",
                icon: <FaIcons.FaCircle className="iconSubmenu" />,
                id: "invoiceNumberInvalidate"
            }
        ]
    },
    // {
    //     title: "credit_notes",
    //     path: "/ElectronicBilling/CreditNote",
    //     icon: <FaIcons.FaReceipt />,
    //     iconClosed: <RiIcons.RiArrowDownSFill />,
    //     iconOpened: <RiIcons.RiArrowUpSFill />
    // },
    {
        id: "Faq",
        title: "invoice_data",
        path: "/ElectronicBilling/Faq",
        icon: <FaIcons.FaIdCard />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        isClicked: false,
        adminOnly: true,
    },
    {
        id: "Products",
        title: "default_products",
        path: "/ElectronicBilling/Products",
        icon: <FaIcons.FaCartPlus />,
        iconClosed: <FaIcons.FaChevronDown className="arrowIcon" />,
        iconOpened: <FaIcons.FaChevronDown className="arrowIcon" />,
        isClicked: false,
        subNav: [
            {
                title: "default_search",
                path: "/ElectronicBilling/Products",
                icon: <FaIcons.FaCircle className="iconSubmenu" />,
                id: "productsElectronicBilling"
            },
            {
                title: "default_import",
                path: "/ElectronicBilling/ImportProducts",
                icon: <FaIcons.FaCircle className="iconSubmenu" />,
                id: "importElectronicBilling",
                adminOnly: true
            }
        ]
    },
    // {
    //     title: "price_list",
    //     path: "/ElectronicBilling/PriceList",
    //     icon: <FaIcons.FaTags />,
    //     iconClosed: <RiIcons.RiArrowDownSFill />,
    //     iconOpened: <RiIcons.RiArrowUpSFill />,

    // },
    {
        id: "Management",
        title: "document_limits",
        path: "/ElectronicBilling/Management",
        icon: <FaIcons.FaChartLine />,
        iconClosed: <FaIcons.FaChevronDown className="arrowIcon" />,
        iconOpened: <FaIcons.FaChevronDown className="arrowIcon" />,
        isClicked: false,
        adminOnly: true,
        subNav: [
            {
                title: "management",
                path: "/ElectronicBilling/Management",
                icon: <FaIcons.FaCircle className="iconSubmenu" />,
                className: "justAdmin",
                id: "documentsLimitsManagement",
            },
            {
                title: "statistics",
                path: "/ElectronicBilling/Statistics",
                icon: <FaIcons.FaCircle className="iconSubmenu" />,
                id: "documentsLimitsStatistics"
            }
        ]
    },
    {
        id: "Configs",
        title: "settings_title",
        path: "/ElectronicBilling/Configs",
        icon: <FaIcons.FaCog />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        isClicked: false,
        adminOnly: true,
    }
]
